import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import "./index.css";
import Shopping from "../../assets/media/eco-token/shopping.svg";
import Pound from "../../assets/media/eco-token/pound.png";
class EcoToken extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      brand: "",
      role: "",
      loading: true,
      communityMembers: [],
      shoppingTokens: 0,
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      console.log("role", role);
      console.log("brand", brand);
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        if (!brand_data) return;
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
          loading: false,
        });
        //get sum of users tokens
        let users = await Firebase.getAllUsersInBrand(brand_data.name);

        const reducer = (sum, currentUser) => {
          let { tokenSpent, tokens } = currentUser;
          let tP = tokenSpent || 0;
          let t = tokens || 0;
          sum = sum + t - tP;
          return sum;
        };
        let token_sum = users.reduce(reducer, 0);
        this.setState({ shoppingTokens: token_sum });
      });
    }
  }

  render() {
    const {
      username,
      role,
      loading,
      logo,
      brand,
      brand_name,
      is_property_brand,
      shoppingTokens,
    } = this.state;

    return (
      <div id="page-container" className="eco-token-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && (
            <div className="content-container">
              <div className="token-container">
                <div className="token">
                  <img src={Shopping} alt="token-icon"></img>
                  <div className="token-info-container">
                    <p className="token-info-container__title">Shopping</p>
                    <p className="token-info-container__number">
                      <b>{shoppingTokens}</b> tokens
                    </p>
                  </div>
                  <p className="token-info-description">
                    Spend on shopping in EcoPay & EcoStore at 3-20 tokens per £1
                  </p>
                </div>
                <div className="token">
                  <img src={Pound} alt="token-icon"></img>
                  <div className="token-info-container">
                    <p className="token-info-container__title">Premier</p>
                    <p className="token-info-container__number">
                      <b>0</b> tokens
                    </p>
                  </div>
                  <p className="token-info-description">
                    Spend on shopping in EcoPay & EcoStore at full value on
                    spend
                  </p>
                </div>
              </div>
              <button className="btn btn-yellow">Add a new custom pot</button>
            </div>
          )}
        </main>
      </div>
    );
  }
}

export default EcoToken;



// WEBPACK FOOTER //
// ./src/screens/EcoToken/index.js